// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3JIZR","clinicsSelect":"TableHeading_clinicsSelect__1vg9C"};